import parseColor from 'parse-color';

//re-export
export { parseColor };

export const inverseColor = (r: number, g: number, b: number) => {
  const inverse = [255 - r, 255 - g, 255 - b];
  return parseColor(`rgb(${inverse[0]}, ${inverse[1]}, ${inverse[2]})`);
};

// Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
export const getColorLuminance = (r: number, g: number, b: number) => {
  const srgb = [r, g, b].map((value) => value / 255);
  const [rr, gg, bb] = srgb.map((value) =>
    value <= 0.03928 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4),
  );

  const lum = 0.2126 * rr + 0.7152 * gg + 0.0722 * bb;

  return lum;
};

// Definition: https://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
export const getColorContrastRatio = (c1: [number, number, number], c2: [number, number, number]) => {
  const c1l = getColorLuminance(c1[0], c1[1], c1[2]);
  const c2l = getColorLuminance(c2[0], c2[1], c2[2]);

  const light = Math.max(c1l, c2l);
  const dark = Math.min(c1l, c2l);

  const contrast = (light + 0.05) / (dark + 0.05);

  return Math.floor(contrast * 100) / 100;
};

// get best color contrast for a given color
export const getBestColorContrast = (color: string) => {
  const parsed = parseColor(color);
  const [r, g, b] = parsed.rgb;
  const luminance = getColorLuminance(r, g, b);
  return luminance > 0.5 ? 'black' : 'white'
};
